module.exports = __webpack_public_path__ + "img/daiban.3d0bb843.png";